import { createContext } from 'react';

/**
 * The footer state context type
 */
export interface FooterStateContextType {
  /**
   * Set the visibility of the footer
   * @param _ True, to show the footer. False, to hide the footer
   */
  showFooter: (_: boolean) => void;
  /**
   * Set the visbility of the navigation within the footer
   * @param _ True, to show the navigation within the footer. False, to hide it
   */
  showFooterNav: (_: boolean) => void;
}

/**
 * The footer context
 */
const FooterContext = createContext<FooterStateContextType>({
  showFooter: () => {
    /* intentionally left blank */
  },
  showFooterNav: () => {
    /* intentionally left blank */
  },
});

export default FooterContext;
